import { ChangeDetectorRef, Directive, Input, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { Holiday2021Service } from '../holiday-2021/holiday-2021.service';

@Directive({
  selector: '[lohiH2021Announce]',
})
export class H2021AnnounceDirective implements OnDestroy {
  private hasView = false;
  private subscription: Subscription;

  @Input() public lohiH2021Announce: any;

  constructor(
    private service: Holiday2021Service,
    private cd: ChangeDetectorRef,
    private viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<any>,
  ) {
    this.setup();
  }

  public ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private setup() {
    this.subscription = this.service.isOpenToAll$.subscribe((isOpenToAll) => {
      if (isOpenToAll) {
        if (!this.hasView) {
          this.viewContainer.createEmbeddedView(this.templateRef);
          this.hasView = true;
          this.cd.markForCheck();
        }
      } else {
        if (this.hasView) {
          this.viewContainer.clear();
          this.hasView = false;
          this.cd.markForCheck();
        }
      }
    });
  }
}
